const setRef = (innerRef, ref) => {
  return (node) => {
    innerRef.current = node;
    if (typeof ref === 'function') {
      ref(node);
      return;
    }
    if (ref) {
      ref.current = node;
    }
  };
};

export default setRef;
